import { GeneralSetting, User } from '@apis/index'
import { Shereabook } from '@assets/images'
import Button from '@components/button'
import Fields from '@components/fields'
import Image from '@components/image'
import Typography from '@components/typography'
import { AuthSchema } from '@validations'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import {
  AuthCard,
  AuthContainer,
  AuthHeader,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
import GoBack from '@components/back'
import { useSelector } from 'react-redux'
import HelmetSeo from '@components/HelmetSeo'
const PhonePage = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = { ...values }
    await User.requestOtp(payload)
      .then((res) => {
        if (res) {
          navigate('/otp-verify', {
            state: {
              ...payload,
              token: res.token,
            },
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const { data: registerSeo } = useSelector((state: any) => state.registerSeo)
  const fetchHomeSeo = async (state: string, key: string) => {
    await GeneralSetting.getByKey(state, key).catch(() => {})
  }

  const [initialValues, setInitialValues] = useState({
    metaTitle: '',
    metaDescription: '',
    metaKeyword: '',
  })
  useEffect(() => {
    if (!!registerSeo?.id) {
      const registerSeoValue = !!registerSeo?.value
        ? JSON.parse(registerSeo?.value)
        : null
      setInitialValues({
        metaTitle: registerSeoValue?.metaTitle,
        metaDescription: registerSeoValue?.metaDescription,
        metaKeyword: registerSeoValue?.metaKeyword,
      })
    }
  }, [registerSeo?.id])
  useEffect(() => {
    if (!registerSeo?.id) {
      fetchHomeSeo('registerSeo', 'registerSeo')
    }
  }, [])

  return (
    <>
      <HelmetSeo
        title={initialValues?.metaTitle}
        description={initialValues?.metaDescription}
        keywords={initialValues?.metaKeyword}
      />
      <AuthWrapper>
        <AuthCard>
          <AuthContainer>
            <GoBack visibleForDesktop={false} />
            <AuthHeader>
              <Typography variant="h3">Get Started with</Typography>
              <Image src={Shereabook} customStyle={'height: 50px'} />
            </AuthHeader>

            <Formik
              initialValues={{
                phoneNo: '',
                purpose: 'Register',
                countryCode: '977',
              }}
              enableReinitialize
              validationSchema={AuthSchema.phoneValidationSchema}
              onSubmit={submitHandler}
            >
              {({ handleSubmit, setFieldValue }) => {
                return (
                  <FormWrapper>
                    <Form onSubmit={handleSubmit}>
                      <FormContainer>
                        <FormInputsContainer>
                          <Fields.PhoneInput
                            name="phoneNo"
                            label="Mobile Number"
                            styleInput="border:1px solid #000; "
                            placeholder="Enter your mobile number"
                            styleWrapper="margin:40px auto; "
                            onChangeCode={(codes) => {
                              setFieldValue('countryCode', codes.callingCode)
                            }}
                          />
                        </FormInputsContainer>
                        <BottomSection>
                          <AuthFooter
                            content="I am already Registered?"
                            tag="Login Now"
                            onClick={() => navigate('/login')}
                          />
                          <Button
                            title="Get Started"
                            styleButton="width:100%; margin-top:10px;"
                            height={45}
                            type="submit"
                            loading={loading}
                          />
                        </BottomSection>
                      </FormContainer>
                    </Form>
                  </FormWrapper>
                )
              }}
            </Formik>
          </AuthContainer>
        </AuthCard>
      </AuthWrapper>
    </>
  )
}

export default PhonePage
